import {ButtonFieldsFragment} from '@common/hygraph-schema';
import {Button, LoadMoreButton} from '../molecules';
import {ExtraProps} from '@/types/hygraph.types';

export const getButtons = (props: ButtonFieldsFragment, extraProps?: ExtraProps) => {
	const otherProps = extraProps ? extraProps(props, 0) : {};
	const analyticProps = otherProps?.analytics ?? {};

	switch (props.ukey) {
		case 'showMoreOffers': {
			return (
				<LoadMoreButton
					key={`components-load-more-btn-${props.ukey}`}
					{...props}
					{...otherProps}
					// temp hard coded props, source from cms in improvements
					sandboxId="fn"
					analytics={{
						eventCategory: 'button',
						interactionType: 'click',
						eventAction: 'showMore',
						eventLabel: 'Show More Products',
						...analyticProps,
						eventValue: {
							interactedElement: 'Button_ShowMore',
							...analyticProps.eventValue
						}
					}}
				/>
			);
		}
		default:
			return (
				<Button
					key={`components-base-btn-${props.ukey}`}
					{...props}
					{...otherProps}
					analytics={{
						eventCategory: 'button',
						interactionType: 'click',
						...analyticProps
					}}
				/>
			);
	}
};
